// FamilyFriendly 家庭友好企业 translations
export const familyFriendlyResources = {
  zh: {
    // Promo page
    'ff.promo.hero.badge': '家庭友好企业',
    'ff.promo.hero.title': '家庭友好，\n成就丰富人生',
    'ff.promo.hero.subtitle': '寻找并致敬真正支持家庭、关爱社会的家庭友好企业',
    'ff.promo.hero.btn.register': '企业参评报名',
    'ff.promo.hero.btn.criteria': '了解评选规则',

    'ff.promo.why.title': '家庭友好，为企业注入新动力',
    'ff.promo.why.subtitle': '关注家庭友好，企业会获得什么？',
    'ff.promo.why.card0.title': '增强雇主品牌吸引力',
    'ff.promo.why.card0.item0': '年轻及顶尖人才愈发关注工作生活平衡与灵活办公',
    'ff.promo.why.card0.item1': '家庭友好建设有助于构建差异化雇主品牌吸引人才',
    'ff.promo.why.card1.title': '激发组织创新活力',
    'ff.promo.why.card1.item0': '家庭友好举措营造员工心理安全感，激发创造力',
    'ff.promo.why.card1.item1': '打造更具创新力和韧性的人才队伍',
    'ff.promo.why.card2.title': '推动企业可持续发展',
    'ff.promo.why.card2.item0': '将"投资于人"转化为企业品牌价值',
    'ff.promo.why.card2.item1': '降低风险、驱动创新，提升社会认可度',

    'ff.promo.dim.title.pre': '我们正在寻找什么样的',
    'ff.promo.dim.title.accent': '家庭友好企业',
    'ff.promo.dim.subtitle':
      '参考联合国儿童基金会（UNICEF）家庭友好政策框架及国内外研究成果，深度评估，挖掘真正的行业标杆',
    'ff.promo.dim.cat.employee': '雇员家庭友好支持',
    'ff.promo.dim.cat.csr': '家庭友好社会贡献',
    'ff.promo.dim.time.title': '时间灵活友好',
    'ff.promo.dim.time.desc': '假期充裕，灵活办公，让家庭安排从容不迫。',
    'ff.promo.dim.money.title': '资金资源友好',
    'ff.promo.dim.money.desc': '专项资金，定向投入，为家庭友好提供坚实后盾。',
    'ff.promo.dim.care.title': '服务照护友好',
    'ff.promo.dim.care.desc': '托育健康，全面关怀，让员工后顾无忧轻装上阵。',
    'ff.promo.dim.culture.title': '职业文化友好',
    'ff.promo.dim.culture.desc': '公平发展，包容氛围，让成长和家庭不是单选题。',
    'ff.promo.dim.csr.title': '家庭友好社会贡献',
    'ff.promo.dim.csr.desc': '产品服务，公益慈善，把惠及更多家庭视为己任。',
    'ff.promo.dim.credible':
      '评审由企业自评、抽样验证，以及专家评审共同完成，确保评审过程专业严谨，结果权威可信。',
    'ff.promo.dim.credible.tag0': '公益开放',
    'ff.promo.dim.credible.tag1': '独立评估',
    'ff.promo.dim.credible.tag2': '证据驱动',

    'ff.promo.experts.title': '专家评审团',
    'ff.promo.experts.subtitle': '专家智库评审论证，护航家庭友好建设有序落地',

    'ff.promo.process.title': '评审路线图',
    'ff.promo.process.subtitle': '从报名到发布，每一步都清晰',
    'ff.promo.process.step0': '企业报名',
    'ff.promo.process.step0.date': '2026.08.05 - 2026.10.09',
    'ff.promo.process.step1': '调研评审',
    'ff.promo.process.step1.date': '报名后 - 2026.10',
    'ff.promo.process.step2': '结果确认',
    'ff.promo.process.step2.date': '2026.11 — 2026.12',
    'ff.promo.process.step3': '榜单发布',
    'ff.promo.process.step3.date': '2027.01',

    'ff.promo.benefits.title.pre': '加入我们，共同助力打造',
    'ff.promo.benefits.title.accent': '家庭友好企业',
    'ff.promo.benefits.subtitle': '让好的制度被看见，也让企业获得更清晰的家庭友好优化方向',
    'ff.promo.benefits.report.title': '定制化专业评估报告',
    'ff.promo.benefits.report.body':
      '所有符合要求的参评企业，均可获得针对本企业家庭友好实践的科学、系统的评估，提供定制化分析报告、行业 Benchmark 及优秀实践案例参考。',
    'ff.promo.benefits.brand.title': '荣誉认可与品牌背书',
    'ff.promo.benefits.brand.body':
      '通过合规性审核的企业可获得家庭友好型企业认证；优秀实践企业将依据综合评审结果入选家庭友好企业榜单及年度标杆案例，获得专业机构权威认可，持续提升企业品牌影响力及雇主品牌竞争力。',
    'ff.promo.benefits.media.title': '权威媒体品牌曝光',
    'ff.promo.benefits.media.body':
      '榜单将联合中国新闻周刊等权威媒体，打造高规格传播矩阵，通过专题报道、深度解读等多元传播形式，为企业提供权威品牌背书。',
    'ff.promo.benefits.resource.title': '高质量行业资源触达',
    'ff.promo.benefits.resource.body':
      '上榜企业将受邀参与在2027年1月于香港举办的"全球生育危机论坛"等行业活动，为企业提供高质量行业交流机会，自动激活大会现场及全网的百万量级曝光资源。',

    'ff.promo.join.title': '你的声音，能让改变发生',
    'ff.promo.join.subtitle':
      '无论你是企业管理者，还是期待公司变得更友好的员工，都可以推动一次具体改变',
    'ff.promo.join.company.title': '企业参评报名',
    'ff.promo.join.company.body':
      '如果您的企业在家庭友好方面有所实践，欢迎正式报名参与评选，让温暖制度被更多人看见。',
    'ff.promo.join.company.btn': '进入报名入口',
    'ff.promo.join.share.title': '分享给你的 HR',
    'ff.promo.join.share.body': '生成一张邀请卡片，转发给公司管理层或 HR，推动企业加入家庭友好动。',
    'ff.promo.join.share.btn': '生成分享卡片',

    'ff.promo.voices.title': '关于家庭友好，TA们这样说',
    'ff.promo.voices.subtitle': '来自员工、主管和消费者的真实声音，家庭友好不仅停留在口号上',
    'ff.promo.voices.0.name': '某互联网公司员工',
    'ff.promo.voices.0.role': '研发团队 / 新手妈妈',
    'ff.promo.voices.0.tag': '哺乳室',
    'ff.promo.voices.0.quote':
      '"我们公司有专门的哺乳室，哺乳椅、冰箱、消毒柜都有，我可以轻松为孩子准备母乳，不用麻烦任何人，我感受到了公司对职场妈妈的尊重。"',
    'ff.promo.voices.1.name': '某餐饮公司员工',
    'ff.promo.voices.1.role': '门店运营 / 新手爸爸',
    'ff.promo.voices.1.tag': '陪产假，生育奖励',
    'ff.promo.voices.1.quote':
      '"陪产假优于法定，让我有更多时间照顾妻儿；新生儿奖励金更添惊喜，真切感受到公司对家庭的关怀，让我对公司多了一份感动与归属。"',
    'ff.promo.voices.2.name': '某制造企业主管',
    'ff.promo.voices.2.role': '部门主管',
    'ff.promo.voices.2.tag': '灵活工时',
    'ff.promo.voices.2.quote':
      '"我们允许员工灵活办公，我的团队成员可以先安排好家庭的事务，再安心处理工作上的事情。他们没有后顾之忧，效率更高了，氛围也更融洽了。"',
    'ff.promo.voices.3.name': '某消费品牌用户',
    'ff.promo.voices.3.role': '消费者 / 多孩家庭',
    'ff.promo.voices.3.tag': '家庭友好产品',
    'ff.promo.voices.3.quote':
      '"这个品牌的产品能满足像我这样的多孩家庭的需求。听说这家公司对员工家庭也支持颇多——用心待员工，自然用心待用户，让我更加信赖它。"',

    'ff.nav.overview': '评选首页',
    'ff.nav.questionnaire': '参评问卷',
    'ff.nav.companyInfo': '企业信息',
    'ff.nav.badge.pending': '待填写',

    'ff.questionnaire.title': '家庭友好型企业 · 调研问卷',
    'ff.questionnaire.subtitle':
      '感谢您参加此次家庭友好企业调查！问卷分为{{count}}个模块，预计填写时长 20-30 分钟，可分阶段保存草稿。详情可点击',
    'ff.questionnaire.subtitle.link': '参评问卷须知',
    'ff.questionnaire.subtitle.post': '。',
    'ff.questionnaire.progressLabel': '进度：',
    'ff.questionnaire.answerCardLabel': '答题卡：',
    'ff.questionnaire.status.done': '已完成',
    'ff.questionnaire.status.doing': '进行中',
    'ff.questionnaire.status.undone': '未完成',
    'ff.questionnaire.textPlaceholder': '请输入内容',
    'ff.questionnaire.prevQuestion': '上一题',
    'ff.questionnaire.nextQuestion': '下一题',
    'ff.questionnaire.answeredCount': '已填写题数：',
    'ff.questionnaire.submit': '提交问卷',
    'ff.questionnaire.saveDraft': '保存草稿',
    'ff.questionnaire.saveDraftSuccess': '草稿已保存',
    'ff.questionnaire.saveDraftError': '保存失败，请重试',
    'ff.questionnaire.submitError': '提交失败，请重试',

    'ff.questionnaire.success.title': '调研问卷提交成功！',
    'ff.questionnaire.success.desc': '调研问卷提交成功，请等待后续抽题验证',
    'ff.questionnaire.success.btn': '返回',

    'ff.questionnaire.incomplete.title': '调研问卷提交失败',
    'ff.questionnaire.incomplete.desc1': '您的调研问卷中仍有未完成的题目，无法进行提交',
    'ff.questionnaire.incomplete.desc2': '请完成后再次尝试提交',
    'ff.questionnaire.incomplete.pending': '待完成：',
    'ff.questionnaire.incomplete.btn': '去完成',

    'ff.questionnaire.notice.title': '参评问卷须知',
    'ff.questionnaire.notice.btn': '去填写',
    'ff.questionnaire.notice.entry': '参评问卷须知',

    'ff.companyInfo.title': '企业信息维护',
    'ff.companyInfo.accountLabel': '企业账号',
    'ff.companyInfo.accountReadonly': '不可修改',
    'ff.companyInfo.accountNote': '*企业账号作为唯一标识，可与登录邮箱共同用于登录系统，不可修改',
    'ff.companyInfo.companyName': '企业名称',
    'ff.companyInfo.accountHint': '企业名称不可修改',
    'ff.companyInfo.contactName': '联系人姓名',
    'ff.companyInfo.contactTitle': '联系人岗位',
    'ff.companyInfo.email': '登录邮箱',
    'ff.companyInfo.emailHint':
      '修改邮箱后，新邮箱即可作为登录账号；旧邮箱将无法登录，但企业账号仍可使用',
    'ff.companyInfo.phone': '联系人手机',
    'ff.companyInfo.saveError': '保存失败，请重试',
    'ff.companyInfo.saving': '保存中…',
    'ff.companyInfo.save': '保存修改',
    'ff.companyInfo.cancel': '取消',

    'ff.overview.welcome': '欢迎，{name}',
    'ff.overview.subtitle': '您的报名已成功受理，正式参评问卷将在评审阶段开放，敬请关注本页面通知',
    'ff.overview.section.progress': '评选进度',
    'ff.overview.section.companyInfo': '企业报名信息',
    'ff.overview.section.announcements': '评选公告',
    'ff.overview.step.registration': '企业报名',
    'ff.overview.step.materials': '问卷调研',
    'ff.overview.step.review': '抽样验证',
    'ff.overview.step.publish': '榜单公布',
    'ff.overview.status.done': '已完成',
    'ff.overview.status.active': '进行中',
    'ff.overview.status.locked': '未开放',
    'ff.overview.notice': '*家庭友好企业参评问卷已开放填写，请于 {{deadline}} 之前完成调研',
    'ff.overview.btn.survey': '参与调研',
    'ff.overview.btn.edit': '修改',
    'ff.overview.info.companyName': '企业名称',
    'ff.overview.info.account': '企业账号',
    'ff.overview.info.email': '登录邮箱',
    'ff.overview.info.contact': '联系人',
    'ff.overview.announcement.preview': '预告',
    'member.notFound': '未找到该成员',
  },
  zh_TW: {
    // Promo page
    'ff.promo.hero.badge': '家庭友善企業',
    'ff.promo.hero.title': '家庭友善，\n成就豐富人生',
    'ff.promo.hero.subtitle': '尋找並致敬真正支持家庭、關愛社會的家庭友善企業',
    'ff.promo.hero.btn.register': '企業參評報名',
    'ff.promo.hero.btn.criteria': '了解評選規則',

    'ff.promo.why.title': '家庭友善，為企業注入新動力',
    'ff.promo.why.subtitle': '關注家庭友善，企業會獲得什麼？',
    'ff.promo.why.card0.title': '增強雇主品牌吸引力',
    'ff.promo.why.card0.item0': '年輕及頂尖人才愈發關注工作生活平衡與靈活辦公',
    'ff.promo.why.card0.item1': '家庭友善建設有助於構建差異化雇主品牌吸引人才',
    'ff.promo.why.card1.title': '激發組織創新活力',
    'ff.promo.why.card1.item0': '家庭友善舉措營造員工心理安全感，激發創造力',
    'ff.promo.why.card1.item1': '打造更具創新力和韌性的人才隊伍',
    'ff.promo.why.card2.title': '推動企業可持續發展',
    'ff.promo.why.card2.item0': '將「投資於人」轉化為企業品牌價值',
    'ff.promo.why.card2.item1': '降低風險、驅動創新，提升社會認可度',

    'ff.promo.dim.title.pre': '我們正在尋找什麼樣的',
    'ff.promo.dim.title.accent': '家庭友善企業',
    'ff.promo.dim.subtitle':
      '參考聯合國兒童基金會（UNICEF）家庭友善政策框架及國內外研究成果，深度評估，挖掘真正的行業標杆',
    'ff.promo.dim.cat.employee': '雇員家庭友善支持',
    'ff.promo.dim.cat.csr': '家庭友善社會貢獻',
    'ff.promo.dim.time.title': '時間靈活友好',
    'ff.promo.dim.time.desc': '假期充裕，靈活辦公，讓家庭安排從容不迫。',
    'ff.promo.dim.money.title': '資金資源友好',
    'ff.promo.dim.money.desc': '專項資金，定向投入，為家庭友善提供堅實後盾。',
    'ff.promo.dim.care.title': '服務照護友好',
    'ff.promo.dim.care.desc': '托育健康，全面關懷，讓員工後顧無憂輕裝上陣。',
    'ff.promo.dim.culture.title': '職業文化友好',
    'ff.promo.dim.culture.desc': '公平發展，包容氛圍，讓成長和家庭不是單選題。',
    'ff.promo.dim.csr.title': '家庭友善社會貢獻',
    'ff.promo.dim.csr.desc': '產品服務，公益慈善，把惠及更多家庭視為己任。',
    'ff.promo.dim.credible':
      '評審由企業自評、抽樣驗證，以及專家評審共同完成，確保評審過程專業嚴謹，結果權威可信。',
    'ff.promo.dim.credible.tag0': '公益開放',
    'ff.promo.dim.credible.tag1': '獨立評估',
    'ff.promo.dim.credible.tag2': '證據驅動',

    'ff.promo.experts.title': '專家評審團',
    'ff.promo.experts.subtitle': '專家智庫評審論證，護航家庭友善建設有序落地',

    'ff.promo.process.title': '評審路線圖',
    'ff.promo.process.subtitle': '從報名到發布，每一步都清晰',
    'ff.promo.process.step0': '企業報名',
    'ff.promo.process.step0.date': '2026.08.05 - 2026.10.09',
    'ff.promo.process.step1': '研究評審',
    'ff.promo.process.step1.date': '報名後 - 2026.10',
    'ff.promo.process.step2': '結果確認',
    'ff.promo.process.step2.date': '2026.11 — 2026.12',
    'ff.promo.process.step3': '榜單發布',
    'ff.promo.process.step3.date': '2027.01',

    'ff.promo.benefits.title.pre': '加入我們，共同助力打造',
    'ff.promo.benefits.title.accent': '家庭友善企業',
    'ff.promo.benefits.subtitle': '讓好的制度被看見，也讓企業獲得更清晰的家庭友善優化方向',
    'ff.promo.benefits.report.title': '定制化專業評估報告',
    'ff.promo.benefits.report.body':
      '所有符合要求的參評企業，均可獲得針對本企業家庭友善實踐的科學、系統的評估，提供定制化分析報告、行業 Benchmark 及優秀實踐案例參考。',
    'ff.promo.benefits.brand.title': '榮譽認可與品牌背書',
    'ff.promo.benefits.brand.body':
      '通過合規性審核的企業可獲得家庭友善型企業認證；優秀實踐企業將依據綜合評審結果入選家庭友善企業榜單及年度標杆案例，獲得專業機構權威認可，持續提升企業品牌影響力及雇主品牌競爭力。',
    'ff.promo.benefits.media.title': '權威媒體品牌曝光',
    'ff.promo.benefits.media.body':
      '榜單將聯合中國新聞週刊等權威媒體，打造高規格傳播矩陣，通過專題報道、深度解讀等多元傳播形式，為企業提供權威品牌背書。',
    'ff.promo.benefits.resource.title': '高質量行業資源觸達',
    'ff.promo.benefits.resource.body':
      '上榜企業將受邀參與在2027年1月於香港舉辦的「全球生育危機論壇」等行業活動，為企業提供高質量行業交流機會，自動激活大會現場及全網的百萬量級曝光資源。',

    'ff.promo.join.title': '你的聲音，能讓改變發生',
    'ff.promo.join.subtitle':
      '無論你是企業管理者，還是期待公司變得更友好的員工，都可以推動一次具體改變',
    'ff.promo.join.company.title': '企業參評報名',
    'ff.promo.join.company.body':
      '如果您的企業在家庭友善方面有所實踐，歡迎正式報名參與評選，讓溫暖制度被更多人看見。',
    'ff.promo.join.company.btn': '進入報名入口',
    'ff.promo.join.share.title': '分享給你的 HR',
    'ff.promo.join.share.body': '生成一張邀請卡片，轉發給公司管理層或 HR，推動企業加入家庭友善動。',
    'ff.promo.join.share.btn': '生成分享卡片',

    'ff.promo.voices.title': '關於家庭友善，TA們這樣說',
    'ff.promo.voices.subtitle': '來自員工、主管和消費者的真實聲音，家庭友善不僅停留在口號上',
    'ff.promo.voices.0.name': '某互聯網公司員工',
    'ff.promo.voices.0.role': '研發團隊 / 新手媽媽',
    'ff.promo.voices.0.tag': '哺乳室',
    'ff.promo.voices.0.quote':
      '"我們公司有專門的哺乳室，哺乳椅、冰箱、消毒櫃都有，我可以輕鬆為孩子準備母乳，不用麻煩任何人，我感受到了公司對職場媽媽的尊重。"',
    'ff.promo.voices.1.name': '某餐飲公司員工',
    'ff.promo.voices.1.role': '門店運營 / 新手爸爸',
    'ff.promo.voices.1.tag': '陪產假，生育獎勵',
    'ff.promo.voices.1.quote':
      '"陪產假優於法定，讓我有更多時間照顧妻兒；新生兒獎勵金更添驚喜，真切感受到公司對家庭的關懷，讓我對公司多了一份感動與歸屬。"',
    'ff.promo.voices.2.name': '某製造企業主管',
    'ff.promo.voices.2.role': '部門主管',
    'ff.promo.voices.2.tag': '靈活工時',
    'ff.promo.voices.2.quote':
      '"我們允許員工靈活辦公，我的團隊成員可以先安排好家庭的事務，再安心處理工作上的事情。他們沒有後顧之憂，效率更高了，氛圍也更融洽了。"',
    'ff.promo.voices.3.name': '某消費品牌用戶',
    'ff.promo.voices.3.role': '消費者 / 多孩家庭',
    'ff.promo.voices.3.tag': '家庭友善產品',
    'ff.promo.voices.3.quote':
      '"這個品牌的產品能滿足像我這樣的多孩家庭的需求。聽說這家公司對員工家庭也支持頗多——用心待員工，自然用心待用戶，讓我更加信賴它。"',

    'ff.nav.overview': '評選首頁',
    'ff.nav.questionnaire': '參評問卷',
    'ff.nav.companyInfo': '企業信息',
    'ff.nav.badge.pending': '待填寫',

    'ff.questionnaire.title': '家庭友善型企業 · 調研問卷',
    'ff.questionnaire.subtitle':
      '感謝您參加此次家庭友善企業調查！問卷分為{{count}}個模塊，預計填寫時長 20-30 分鐘，可分階段保存草稿。詳情可點擊',
    'ff.questionnaire.subtitle.link': '參評問卷須知',
    'ff.questionnaire.subtitle.post': '。',
    'ff.questionnaire.progressLabel': '進度：',
    'ff.questionnaire.answerCardLabel': '答題卡：',
    'ff.questionnaire.status.done': '已完成',
    'ff.questionnaire.status.doing': '進行中',
    'ff.questionnaire.status.undone': '未完成',
    'ff.questionnaire.textPlaceholder': '請輸入內容',
    'ff.questionnaire.prevQuestion': '上一題',
    'ff.questionnaire.nextQuestion': '下一題',
    'ff.questionnaire.answeredCount': '已填寫題數：',
    'ff.questionnaire.submit': '提交問卷',
    'ff.questionnaire.saveDraft': '保存草稿',
    'ff.questionnaire.saveDraftSuccess': '草稿已儲存',
    'ff.questionnaire.saveDraftError': '儲存失敗，請重試',
    'ff.questionnaire.submitError': '提交失敗，請重試',

    'ff.questionnaire.success.title': '調研問卷提交成功！',
    'ff.questionnaire.success.desc': '研究問卷提交成功，請等待後續抽題驗證',
    'ff.questionnaire.success.btn': '返回',

    'ff.questionnaire.incomplete.title': '調研問卷提交失敗',
    'ff.questionnaire.incomplete.desc1': '您的調研問卷中仍有未完成的題目，無法進行提交',
    'ff.questionnaire.incomplete.desc2': '請完成後再次嘗試提交',
    'ff.questionnaire.incomplete.pending': '待完成：',
    'ff.questionnaire.incomplete.btn': '去完成',

    'ff.questionnaire.notice.title': '參評問卷須知',
    'ff.questionnaire.notice.btn': '去填寫',
    'ff.questionnaire.notice.entry': '參評問卷須知',

    'ff.companyInfo.title': '企業信息維護',
    'ff.companyInfo.accountLabel': '企業賬號',
    'ff.companyInfo.accountReadonly': '不可修改',
    'ff.companyInfo.accountNote': '*企業賬號作為唯一標識，可與登錄郵箱共同用於登錄系統，不可修改',
    'ff.companyInfo.companyName': '企業名稱',
    'ff.companyInfo.accountHint': '企業名稱不可修改',
    'ff.companyInfo.contactName': '聯繫人姓名',
    'ff.companyInfo.contactTitle': '聯繫人崗位',
    'ff.companyInfo.email': '登錄郵箱',
    'ff.companyInfo.emailHint':
      '修改郵箱後，新郵箱即可作為登錄賬號；舊郵箱將無法登錄，但企業賬號仍可使用',
    'ff.companyInfo.phone': '聯繫人手機',
    'ff.companyInfo.saveError': '保存失敗，請重試',
    'ff.companyInfo.saving': '保存中…',
    'ff.companyInfo.save': '保存修改',
    'ff.companyInfo.cancel': '取消',

    'ff.overview.welcome': '歡迎，{name}',
    'ff.overview.subtitle': '您的報名已成功受理，正式參評問卷將在評審階段開放，敬請關注本頁面通知',
    'ff.overview.section.progress': '評選進度',
    'ff.overview.section.companyInfo': '企業報名信息',
    'ff.overview.section.announcements': '評選公告',
    'ff.overview.step.registration': '企業報名',
    'ff.overview.step.materials': '問卷調查',
    'ff.overview.step.review': '抽樣驗證',
    'ff.overview.step.publish': '榜單公布',
    'ff.overview.status.done': '已完成',
    'ff.overview.status.active': '進行中',
    'ff.overview.status.locked': '未開放',
    'ff.overview.notice': '*家庭友善企業參評問卷已開放填寫，請於 {{deadline}} 之前完成調研',
    'ff.overview.btn.survey': '參與調研',
    'ff.overview.btn.edit': '修改',
    'ff.overview.info.companyName': '企業名稱',
    'ff.overview.info.account': '企業賬號',
    'ff.overview.info.email': '登錄郵箱',
    'ff.overview.info.contact': '聯繫人',
    'ff.overview.announcement.preview': '預告',
    'member.notFound': '找不到該成員',
  },
  en: {
    // Promo page
    'ff.promo.hero.badge': 'Family Friendly Employer',
    'ff.promo.hero.title': 'Family-Friendly,\nFulfilling Lives',
    'ff.promo.hero.subtitle':
      'Recognizing enterprises that truly support families and contribute to society',
    'ff.promo.hero.btn.register': 'Register Your Company',
    'ff.promo.hero.btn.criteria': 'Learn Award Criteria',

    'ff.promo.why.title': 'Family-Friendly Initiatives: Empowering Businesses with New Momentum',
    'ff.promo.why.subtitle': 'What can businesses gain by embracing family-friendly practices?',
    'ff.promo.why.card0.title': 'Enhance Employer Brand',
    'ff.promo.why.card0.item0':
      'Young professionals and top talent value work-life balance and flexibility.',
    'ff.promo.why.card0.item1':
      'Family-friendly practices help employers stand out and attract talent.',
    'ff.promo.why.card1.title': 'Drive Innovation',
    'ff.promo.why.card1.item0':
      'Family-friendly practices foster psychological safety and creativity.',
    'ff.promo.why.card1.item1': 'Build a more innovative and resilient workforce.',
    'ff.promo.why.card2.title': 'Sustainable Growth',
    'ff.promo.why.card2.item0': 'Turn investing in people into lasting brand value.',
    'ff.promo.why.card2.item1': 'Reduce risk, drive innovation, and strengthen public trust.',

    'ff.promo.dim.title.pre': 'What Makes a ',
    'ff.promo.dim.title.accent': 'Family-Friendly Employer?',
    'ff.promo.dim.subtitle':
      'Drawing on the UNICEF Family-Friendly Policies Framework and leading global research, we conduct in-depth assessments to identify true industry leaders.',
    'ff.promo.dim.cat.employee': 'Family-Friendly Support for Employees',
    'ff.promo.dim.cat.csr': 'Family-Friendly Social Impact',
    'ff.promo.dim.time.title': 'Time Flexibility Friendly',
    'ff.promo.dim.time.desc': 'Generous leave and flexible work arrangements help families thrive.',
    'ff.promo.dim.money.title': 'Financial Resources Friendly',
    'ff.promo.dim.money.desc':
      'Dedicated resources and targeted investments support family-friendly practices.',
    'ff.promo.dim.care.title': 'Service Care Friendly',
    'ff.promo.dim.care.desc': 'Childcare and health support give employees peace of mind.',
    'ff.promo.dim.culture.title': 'Occupational Culture Friendly',
    'ff.promo.dim.culture.desc':
      'Fair opportunities and an inclusive culture help employees grow at work and at home.',
    'ff.promo.dim.csr.title': 'Family-Friendly Social Impact',
    'ff.promo.dim.csr.desc':
      'Products, services, and philanthropy create a positive impact for more families.',
    'ff.promo.dim.credible':
      'The assessment combines company self-evaluations, sample verification, and expert review to ensure a rigorous process and credible results.',
    'ff.promo.dim.credible.tag0': 'Public Good',
    'ff.promo.dim.credible.tag1': 'Independent',
    'ff.promo.dim.credible.tag2': 'Evidence-Based',

    'ff.promo.experts.title': 'Expert Review Panel',
    'ff.promo.experts.subtitle':
      'Expert advisory review and validation to ensure family-friendly initiatives are implemented properly.',

    'ff.promo.process.title': 'Assessment Journey',
    'ff.promo.process.subtitle':
      'From application to announcement, every step is clear and transparent.',
    'ff.promo.process.step0': 'Company Applications',
    'ff.promo.process.step0.date': 'August 5 – October 9, 2026',
    'ff.promo.process.step1': 'Assessment & Review',
    'ff.promo.process.step1.date': 'After Application - October 2026',
    'ff.promo.process.step2': 'Results Confirmation',
    'ff.promo.process.step2.date': 'November – December 2026',
    'ff.promo.process.step3': 'List Announcement',
    'ff.promo.process.step3.date': 'January 2027',

    'ff.promo.benefits.title.pre': 'Join Us in Building ',
    'ff.promo.benefits.title.accent': 'Family-Friendly Employers',
    'ff.promo.benefits.subtitle':
      'Let good practices be seen, and help enterprises find clearer directions for improvement.',
    'ff.promo.benefits.report.title': 'Tailored Assessment Reports',
    'ff.promo.benefits.report.body':
      'Receive a customized report with insights, industry benchmarks, and best practices for your family-friendly initiatives.',
    'ff.promo.benefits.brand.title': 'Recognition & Brand Endorsement',
    'ff.promo.benefits.brand.body':
      'Eligible companies may earn Family-friendly Employer Certification, and outstanding companies will be recognized in Family-friendly Employers List.',
    'ff.promo.benefits.media.title': 'Media Exposure',
    'ff.promo.benefits.media.body':
      'Listed companies will gain visibility through leading media partnerships and high-impact storytelling opportunities.',
    'ff.promo.benefits.resource.title': 'Industry Connections',
    'ff.promo.benefits.resource.body':
      'Listed companies will be invited to connect with global leaders at Global Fertility Crisis Forum in Hong Kong in January 2027.',

    'ff.promo.join.title': 'Your Voice Can Make Change Happen',
    'ff.promo.join.subtitle':
      "Whether you're a business leader or an employee hoping your company becomes more family-friendly, you can drive concrete change.",
    'ff.promo.join.company.title': 'Enterprise Registration',
    'ff.promo.join.company.body':
      'If your enterprise has implemented family-friendly practices, you are welcome to officially register and participate in the selection — let your warm policies be seen by more people.',
    'ff.promo.join.company.btn': 'Go to Registration',
    'ff.promo.join.share.title': 'Share with Your HR',
    'ff.promo.join.share.body':
      'Generate an invitation card and forward it to company management or HR to encourage your enterprise to join the family-friendly movement.',
    'ff.promo.join.share.btn': 'Generate Share Card',

    'ff.promo.voices.title': 'What They Say About Family-Friendly Employers',
    'ff.promo.voices.subtitle':
      'Real voices from employees, leaders, and consumers—showing that family-friendly practices go beyond words.',
    'ff.promo.voices.0.name': 'Employee, Technology Company',
    'ff.promo.voices.0.role': 'Engineering Team / New Mother',
    'ff.promo.voices.0.tag': 'Lactation Room',
    'ff.promo.voices.0.quote':
      '"Our lactation room makes it easy for me to prepare breast milk at work. It\'s a small gesture that shows real respect for working mothers."',
    'ff.promo.voices.1.name': 'Employee, Restaurant Company',
    'ff.promo.voices.1.role': 'Store Operations / New Father',
    'ff.promo.voices.1.tag': 'Paternity Leave & Baby Bonus',
    'ff.promo.voices.1.quote':
      '"The extended paternity leave gave me more time with my family, and the baby bonus was a wonderful surprise. It made me feel genuinely cared for."',
    'ff.promo.voices.2.name': 'Manager, Manufacturing Company',
    'ff.promo.voices.2.role': 'Department Head',
    'ff.promo.voices.2.tag': 'Flexible Working Hours',
    'ff.promo.voices.2.quote':
      '"Flexible work helps my team balance family and work. With fewer worries at home, they\'re more productive and work better together."',
    'ff.promo.voices.3.name': 'Consumer, Lifestyle Brand',
    'ff.promo.voices.3.role': 'Consumer / Parent of Multiple Children',
    'ff.promo.voices.3.tag': 'Family-Friendly Products',
    'ff.promo.voices.3.quote':
      '"This brand understands the needs of families like mine. Knowing it also supports its employees\' families makes me trust it even more."',

    'ff.nav.overview': 'Overview',
    'ff.nav.questionnaire': 'Questionnaire',
    'ff.nav.companyInfo': 'Company Info',
    'ff.nav.badge.pending': 'Pending',

    'ff.questionnaire.title': 'Family-Friendly Enterprise · Survey',
    'ff.questionnaire.subtitle':
      'Thank you for participating in this survey! The questionnaire has {{count}} modules and takes approximately 20–30 minutes. You may save your progress at any time. For details, see the',
    'ff.questionnaire.subtitle.link': 'Survey Guidelines',
    'ff.questionnaire.subtitle.post': '.',
    'ff.questionnaire.progressLabel': 'Progress:',
    'ff.questionnaire.answerCardLabel': 'Answer Card:',
    'ff.questionnaire.status.done': 'Completed',
    'ff.questionnaire.status.doing': 'In Progress',
    'ff.questionnaire.status.undone': 'Not Started',
    'ff.questionnaire.textPlaceholder': 'Enter your answer here',
    'ff.questionnaire.prevQuestion': 'Previous',
    'ff.questionnaire.nextQuestion': 'Next',
    'ff.questionnaire.answeredCount': 'Answered:',
    'ff.questionnaire.submit': 'Submit',
    'ff.questionnaire.saveDraft': 'Save Draft',
    'ff.questionnaire.saveDraftSuccess': 'Draft saved',
    'ff.questionnaire.saveDraftError': 'Failed to save. Please try again.',
    'ff.questionnaire.submitError': 'Submission failed. Please try again.',

    'ff.questionnaire.success.title': 'Questionnaire Submitted!',
    'ff.questionnaire.success.desc':
      'The survey questionnaire was submitted successfully. Please wait for subsequent question selection and verification.',
    'ff.questionnaire.success.btn': 'Back',

    'ff.questionnaire.incomplete.title': 'Submission Failed',
    'ff.questionnaire.incomplete.desc1':
      'Some questions are still incomplete and cannot be submitted.',
    'ff.questionnaire.incomplete.desc2': 'Please complete them and try again.',
    'ff.questionnaire.incomplete.pending': 'Incomplete: ',
    'ff.questionnaire.incomplete.btn': 'Complete Now',

    'ff.questionnaire.notice.title': 'Survey Guidelines',
    'ff.questionnaire.notice.btn': 'Start Filling',
    'ff.questionnaire.notice.entry': 'Survey Guidelines',

    'ff.companyInfo.title': 'Company Information',
    'ff.companyInfo.accountLabel': 'Enterprise Account',
    'ff.companyInfo.accountReadonly': 'Read-only',
    'ff.companyInfo.accountNote':
      '*The enterprise account is a unique identifier and can be used together with your login email. It cannot be changed.',
    'ff.companyInfo.companyName': 'Company Name',
    'ff.companyInfo.accountHint': 'Company Name cannot be changed',
    'ff.companyInfo.contactName': 'Contact Name',
    'ff.companyInfo.contactTitle': 'Contact Title',
    'ff.companyInfo.email': 'Login Email',
    'ff.companyInfo.emailHint':
      'After updating your email, the new email can be used to log in. The old email will no longer work, but your enterprise account remains valid.',
    'ff.companyInfo.phone': 'Contact Phone',
    'ff.companyInfo.saveError': 'Save failed. Please try again.',
    'ff.companyInfo.saving': 'Saving…',
    'ff.companyInfo.save': 'Save Changes',
    'ff.companyInfo.cancel': 'Cancel',

    'ff.overview.welcome': 'Welcome, {name}',
    'ff.overview.subtitle':
      'Your application has been received. The official questionnaire will be available during the review phase. Please stay tuned.',
    'ff.overview.section.progress': 'Application Progress',
    'ff.overview.section.companyInfo': 'Company Registration Info',
    'ff.overview.section.announcements': 'Announcements',
    'ff.overview.step.registration': 'Registration',
    'ff.overview.step.materials': 'Questionnaire',
    'ff.overview.step.review': 'Verification',
    'ff.overview.step.publish': 'Results',
    'ff.overview.status.done': 'Completed',
    'ff.overview.status.active': 'In Progress',
    'ff.overview.status.locked': 'Not Open',
    'ff.overview.notice':
      '*The Family-Friendly Enterprise questionnaire is now open. Please complete it by {{deadline}}.',
    'ff.overview.btn.survey': 'Take Survey',
    'ff.overview.btn.edit': 'Edit',
    'ff.overview.info.companyName': 'Company Name',
    'ff.overview.info.account': 'Enterprise Account',
    'ff.overview.info.email': 'Login Email',
    'ff.overview.info.contact': 'Contact Person',
    'ff.overview.announcement.preview': 'Preview',
    'member.notFound': 'Member not found',
  },
};
